import { render, staticRenderFns } from "./l2.vue?vue&type=template&id=0303304a"
import script from "./l2.vue?vue&type=script&lang=js"
export * from "./l2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports